/**
 * Sync size limits, shared by every JS writer (desktop MCP pre-checks, the
 * web records backend) — the mirror of `src-tauri/src/sync/mod.rs`
 * `OUTBOX_ITEM_MAX_BYTES` and `sync/push_budget.rs` `PUSH_BATCH_MAX_BYTES`.
 *
 * Both sit just under the SERVER's own limits (backend_pheonix `sync.ex`
 * `payload_size_error`): 262 144 bytes of JSON-encoded `fields` per op and
 * 4 000 000 per push. The per-op value is pinned to the Rust constant by a
 * source scan (`mcpCollectionSize.test.js`).
 */

/** Max bytes of one op's encoded `{set, unset}` (UTF-8). */
export const OUTBOX_ITEM_MAX_BYTES = 250000;

/** Max encoded `fields` bytes in one push (the server refuses over 4 MB). */
export const PUSH_BATCH_MAX_BYTES = 3000000;

/** Envelope bytes counted per op on top of its `fields`. */
export const PUSH_OP_OVERHEAD_BYTES = 300;
